export default function PHP_Variables_Main() {
  return (
    <div>
      <h1>PHP_Variables_Main</h1>
    </div>
  );
}
